import type { ReactNode } from 'react';

import type { EntityLevel } from '@suntex.fim/enums';

import { EntityProvider } from '../context/EntityContext';
import { useSwitchEntity } from '../useSwitchEntity';

import { CommonLayout, type CommonLayoutProps } from './CommonLayout';

interface EntityLayoutShellProps extends Pick<CommonLayoutProps, 'appVersion'> {
  entityLevel: EntityLevel;
  entityId: number | undefined;
  /** Optional domain provider wrapped around the layout (e.g. `TeamProvider`). */
  wrap?: (layout: ReactNode) => ReactNode;
}

/**
 * Exposes the given entity via {@link EntityProvider} and renders the shared
 * {@link CommonLayout} chrome, optionally inside a domain provider. Shared by
 * every layout wrapper; each one only decides where the entity comes from.
 */
export function EntityLayoutShell({
  entityLevel,
  entityId,
  wrap,
  ...chrome
}: Readonly<EntityLayoutShellProps>) {
  const switchEntity = useSwitchEntity();
  const layout = <CommonLayout {...chrome} />;
  return (
    <EntityProvider
      entityLevel={entityLevel}
      entityId={entityId}
      switchEntity={switchEntity}
    >
      {wrap ? wrap(layout) : layout}
    </EntityProvider>
  );
}
